








import Vue from 'vue'
import { CheckboxValue } from '@/models/dataTable'
import CustomCheckbox from '@/components/Common/CustomCheckbox.vue'

interface Props {
  checkboxValue: CheckboxValue
  value: number[]
}
interface Methods {
  toggleCheckbox: (value: CheckboxValue) => void
}

interface Computed {
  model: number[]
}

export default Vue.extend<{}, Methods, Computed, Props>({
  components: {
    CustomCheckbox,
  },
  props: {
    checkboxValue: {
      required: true,
    },
    value: {},
  },
  methods: {
    toggleCheckbox(value) {
      this.$emit('change-checkbox', value)
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
})
